<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">场所名称：</span>
        </div>
        <el-input v-model="formData.name" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">场所位置：</span>
        </div>
        <el-input v-model="formData.location" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">绑定监控：</span>
        </div>
        <div style="flex-direction: column;align-items: flex-start;">
          <div v-for="(item, index) in formData.cameras" :key="index" style="margin-bottom: 10px;">
            <el-select v-model="item.code" size="small" filterable remote reserve-keyword :remote-method="remoteMethod" placeholder="请输入关键字搜索" style="width: 280px">
              <el-option v-for="item in videoDeviceList" :key="item.device"
                         :label="item.deviceName" :value="item.device">
              </el-option>
            </el-select>
            <i class="el-icon-remove-outline" style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;" @click="removePatrolTeamPersonItem(index)" v-if="index > 0"></i>
            <i class="el-icon-circle-plus-outline" style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;" @click="addPatrolTeamPersonItem(index)" v-if="index === formData.cameras.length - 1"></i>
          </div>
        </div>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import {bus} from '../../../utils/bus'
  import {api} from '../../api/SmartDetection'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'smart-detection-add',
    data () {
      return {
        breadcrumb: [{
          value: '配电监测',
          name: 'smart-detection-over-view'
        }, {
          value: '场所管理'
        }],
        mainTitle: '添加场所',
        subheading: '',

        videoDeviceList: [],
        formData: {
          name: '',
          location: '',
          videoDeviceProtocolType: '',
          cameras:[
            {code:"",name:""}
          ]
        },
      }
    },
    created () {
      this.remoteMethod()
    },
    methods: {
      remoteMethod (query) {
        this.getVideoDeviceList(query)
      },
      // 查询监控设备
      getVideoDeviceList (searchKey) {
        this.$axios.post(`${api.getVideoDeviceList}`, {
          searchKey: searchKey || ''
        }).then(res => {
          let list = res.data.data
          list.map(v=>{
            v.device=v.deviceName +'-' +v.deviceCode
          })
          this.videoDeviceList = list
        })
      },

      toManagementPage () {
        this.$router.push({
          name: 'distribution-room-manage'
        })
      },

      // 添加
      confirm () {
        if (!this.formData.name) {
          nError('请输入场所名称')
          return false
        }
        if (!this.formData.location) {
          nError('请输入场所位置')
          return false
        }
        let tempList=[];
        this.formData.cameras.map(v=>{
          tempList.push(v.code)
        })
        if(tempList[0]==''){
          tempList=[]
        }
        this.formData.cameras=tempList;
        this.$axios.post(api.addPowerRoom, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.toManagementPage()
            }
          })
          .catch(errorHandler('添加失败'))
        .finally(()=>{
          this.formData.cameras=[{code:"",name:""}]
        })
      },

      cancel () {
        this.toManagementPage()
      },

      // 增加班组人员
      addPatrolTeamPersonItem(index) {
        if (!this.formData.cameras[index].code) {
          nError("请先选择当前需要绑定的监控");
          return false;
        }
        let obj = {
          code: "",
          name: ""
        };
        this.formData.cameras.push(obj);
      },

      // 删减班组人员
      removePatrolTeamPersonItem(index) {
        this.formData.cameras.splice(index, 1);
      },
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 190px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .el-switch {
    height: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/view/SmartDetection/DistributionRoomManagement/DistributionRoomAdd.vue